module.exports = __webpack_public_path__ + "img/step_two.f8eb0ce9.jpg";